import React, { useState } from 'react'
import moment from 'moment'
import { Col, Row } from 'react-bootstrap'
import { formatNumber } from '@utils/index'

import ProgressBarLinear from '../Charts/ProgressBarLinear.component'
import DashboardCard from '../DasboardCard.component'
import BarChart from '../Charts/BarChart.component'
import ProgressBarCardContent from '../PerformanceBoardPage/ProgressBarCardContent.component'
import BarChartContent from '../BarChartContent.component'
import { YesterdaySideModal } from '@components/layout/Modals'

import {
  hygieneData,
  hygieneDataBodyTitle,
  prodData,
  prodDataBodyTitle,
  hygieneDataPrimaryYAxis,
  collectionData,
  dentistProdData,
  txAcceptanceData,
  txAcceptanceDataYAxis,
  txAcceptanceDataBodyTitle,
  priorTxAccepted,
  priorTxAcceptedDataYAxis,
  priorTxAcceptedBodyTitle,
} from '../DashboardMockData'
import '../DashboardStyle.css'

function Yesterday(): React.ReactElement {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const toggleModal = (): void => {
    setIsModalOpen(!isModalOpen)
  }

  const dateYesterday = moment().subtract(1, 'days').format('dddd MMMM Do')
  const patCount = 25
  const newPatCount = 25
  const totalProd = 20000
  const goal = 10000
  const unschedPat = 3

  return (
    <>
      <Row className="mt-3 p-3 pt-1 pb-1">
        <Col md={12} className="text-black">
          <span className="fs-1 fw-bolder me-2 ">Yesterday</span>
          <span className="fs-3">{dateYesterday}</span>
        </Col>
      </Row>
      <Row className="p-3 pt-0 pb-1">
        <Col md={12} className="">
          <span className="display-6 text-blue1 fw-semibold">
            Good morning,
          </span>
        </Col>
      </Row>
      <Row className="p-3 pt-0 pb-1">
        <Col md={12} className="">
          <span className="fs-1 text-blue1 fw-bold">
            {`Yesterday you saw ${patCount} patients and ${newPatCount} new faces, totaling ${formatNumber(totalProd, true)} in production, which was`}
            <span className="text-blue">{` ${formatNumber(totalProd - goal, true)}  above goal.`}</span>
            {` ${unschedPat} patients were not scheduled for a future appointment.`}
          </span>
        </Col>
      </Row>
      <Row className="p-3 pt-0 pb-1">
        <Col md={12} className="bg-light p-3 mt-2 rounded">
          <Row>
            <Col md={12}>
              <span className="fs-4 fw-bolder text-blue1">{`Month To Date Production Forecast`}</span>
            </Col>
          </Row>
          <Row>
            <Col md={5}>
              <Row className="text-center text-blue1">
                <Col md={2}>
                  <div className="fs-3 fw-bolder">{`$200,000`}</div>
                  <div>{`Completed`}</div>
                </Col>
                <Col md={1} className="fs-3 fw-bolder">
                  <div>
                    <i className="fa fa-plus"></i>
                  </div>
                </Col>
                <Col md={2}>
                  <div className="fs-3 fw-bolder">{`$70,000`}</div>
                  <div>{`Scheduled`}</div>
                </Col>
                <Col md={1} className="fs-3 fw-bolder">
                  <div>
                    <i className="fa fa-equals"></i>
                  </div>
                </Col>
                <Col md={2}>
                  <div className="fs-3 fw-bolder">{`$270,000`}</div>
                  <div>{`Forecasted`}</div>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <div className="text-blue fs-6">{`Estimated $140,000 above goal`}</div>
                </Col>
              </Row>
            </Col>
            <Col md={7} className="text-center">
              <span className="badge rounded-pill text-bg-primary mb-2">
                Goal $140,000
              </span>
              <ProgressBarLinear
                title={'yesterday'}
                currentValue={75}
                unit="currency"
              />
              <span className="badge rounded-pill text-bg-orange mt-2 float-end">
                Forecasted $270,000
              </span>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col md={4}>
          <DashboardCard
            title={'Production'}
            body={
              <BarChartContent
                chart={
                  <BarChart
                    title={'Production'}
                    isTransposed={false}
                    data={prodData}
                  />
                }
                label="Gross"
                data={prodDataBodyTitle}
                icon={'fa fa-caret-up'}
                displayActual={true}
              />
            }
            classNameCard="h-100"
          />
        </Col>
        <Col md={4}>
          <DashboardCard
            title={'NP Hygiene ReAppointment'}
            body={
              <BarChartContent
                chart={
                  <BarChart
                    title={'NP Hygiene ReAppointment'}
                    isTransposed={true}
                    data={hygieneData}
                    primaryYAxis={hygieneDataPrimaryYAxis}
                    onClick={toggleModal}
                  />
                }
                label="Gross"
                data={hygieneDataBodyTitle}
                icon={'fa fa-caret-up'}
                displayActual={true}
              />
            }
            classNameCard="h-100"
          />
        </Col>
        <Col md={4}>
          <DashboardCard
            title={'Collections'}
            body={
              <ProgressBarCardContent
                title={'Collections'}
                progUnit={'$'}
                data={collectionData}
                progressBarHeight="300"
                progressBarWidth="300"
                iconLabel="fa fa-caret-left"
                classNameTextHeader={'dashboard-text-blue'}
                displayPercent={false}
              />
            }
            classNameCard="h-100"
          />
        </Col>
      </Row>
      <Row className="mt-2">
        <Col md={4}>
          <DashboardCard
            title={'Dentist Production Per Visit'}
            body={
              <ProgressBarCardContent
                title={'Dentist Production Per Visit'}
                progUnit={'$'}
                data={dentistProdData}
                progressBarHeight="300"
                progressBarWidth="300"
                iconLabel="fa fa-caret-left"
                classNameTextHeader={'dashboard-text-blue'}
                displayPercent={false}
              />
            }
            classNameCard="h-100"
          />
        </Col>
        <Col md={4}>
          <DashboardCard
            title={'Tx Acceptance %'}
            body={
              <BarChartContent
                chart={
                  <BarChart
                    title={'Tx Acceptance %'}
                    isTransposed={true}
                    data={txAcceptanceData}
                    primaryYAxis={txAcceptanceDataYAxis}
                  />
                }
                label="Gross"
                data={txAcceptanceDataBodyTitle}
                icon={'fa fa-caret-up'}
                displayActual={true}
              />
            }
            classNameCard="h-100"
          />
        </Col>
        <Col md={4}>
          <DashboardCard
            title={'Prior Tx Accepted'}
            body={
              <BarChartContent
                chart={
                  <BarChart
                    title={'Prior Tx Accepted %'}
                    isTransposed={true}
                    data={priorTxAccepted}
                    primaryYAxis={priorTxAcceptedDataYAxis}
                  />
                }
                data={priorTxAcceptedBodyTitle}
                icon={'fa fa-caret-up'}
              />
            }
            classNameCard="h-100"
          />
        </Col>
      </Row>
      <YesterdaySideModal isOpen={isModalOpen} toggleModal={toggleModal} />
    </>
  )
}

export default Yesterday
